import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Card from '../../components/Card'
import Header from '../../components/Header'
import Image from '../../components/Image'
import MedicationDisplay from '../../components/MedicationDisplay'
import OpticNerveProgression from '../../components/OpticNerveProgression'
import OrderedList from '../../components/OrderedList'
import Paginate from '../../components/Paginate'
import Paragraph from '../../components/Paragraph'
import PatientImages from '../../components/PatientImages'
import Prompts from '../../components/Prompts'
import SectionHeader from '../../components/SectionHeader'
import SummaryBullet from '../../components/SummaryBullet'
import Text from '../../components/Text'
import ThirdSessionPrompts from '../../components/ThirdSessionPrompts'
import Video from '../../components/Video'
import VisualFieldProgression from '../../components/VisualFieldProgression'
import lang from '../../stores/lang'
import patient from '../../stores/patient'
import Row from "../../components/Row";
import OCT from "../../components/OCT";
import styled from 'styled-components'

const Circle = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 1.5rem;
  background: ${props => props.color};
  margin-bottom: 1.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`

const TrafficWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Box = styled.div`
  padding: 1.5rem;
  background: gray;
  border-radius: 1.5rem;
  margin-top: 1rem;
`

const TrafficExp = styled.div`
  line-height: 3rem;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`
function TrafficLight(prop) {
  return (
      <TrafficWrap>
        <Box>
          <Circle color="red" />
          <Circle color="yellow" />
          <Circle color="green" />
        </Box>
        <div style={{ marginLeft: '2rem', padding: '1rem' }}>
          <TrafficExp><Text str="prose.redTrafficLight" /></TrafficExp>
          <TrafficExp><Text str="prose.yellowTrafficLight" /></TrafficExp>
          <TrafficExp><Text str="prose.greenTrafficLight" /></TrafficExp>
        </div>
      </TrafficWrap>
  )
}
@observer
export default class LearnSession123 extends Component {
  render() {
    const { session, demo } = this.props
    const firstSession = session === 'first'
    const thirdSession = session === 'third'
    const patientID = patient.fields._id
    const diagnosisText = lang.translate(`choices.diagnosis.${patient.fields.diagnosis}`)

    const octLeft = [patient.fields.octLeftS, patient.fields.octLeftN, patient.fields.octLeftI, patient.fields.octLeftT]
    const octRight = [patient.fields.octRightS, patient.fields.octRightN, patient.fields.octRightI, patient.fields.octRightT]

    const octLeftGreen = parseInt(octLeft.reduce((s, v) => v === 'GREEN' ? s + 1 : s, 0) / 4 * 100, 10)
    const octLeftYellow = parseInt(octLeft.reduce((s, v) => v === 'YELLOW' ? s + 1 : s, 0) / 4 * 100, 10)
    const octLeftRed = parseInt(octLeft.reduce((s, v) => v === 'RED' ? s + 1 : s, 0) / 4 * 100, 10)

    const octRightGreen = parseInt(octRight.reduce((s, v) => v === 'GREEN' ? s + 1 : s, 0) / 4 * 100, 10)
    const octRightYellow = parseInt(octRight.reduce((s, v) => v === 'YELLOW' ? s + 1 : s, 0) / 4 * 100, 10)
    const octRightRed = parseInt(octRight.reduce((s, v) => v === 'RED' ? s + 1 : s, 0) / 4 * 100, 10)

    return (
      <Fragment>
        {/* YOUR GLAUCOMA */}
        {firstSession &&
          <Prompts>
            <Prompts.P str="prose.iWantToTellYou" />
          </Prompts>
        }
        <SectionHeader color="blue" icon="far fa-dot-circle" str="titles.yourGlaucoma" />
        {!thirdSession &&
          <Prompts>
            {patient.fields.diagnosis === "SUSPECT" &&
              <Prompts.Q str="prose.iKnowDoctorDiagnosedSuspect" inserts={{ doctor: patient.fields.doctor }} />
            }
            {patient.fields.diagnosis !== "SUSPECT" &&
              <Prompts.Q str="prose.iKnowDoctorDiagnosed" inserts={{ doctor: patient.fields.doctor, diagnosis: diagnosisText }} />
            }
            <Prompts.R str="prose.itSoundsLike" />
            <Prompts.Q str="prose.tellMeWhatYou" inserts={{ diagnosis: diagnosisText }} />
            <Prompts.R str="prose.youKnowGlaucomaCan" />
            <Prompts.P str="prose.wouldItBeOkay" inserts={{ diagnosis: diagnosisText }} />
          </Prompts>
        }
        <Video />
        {thirdSession && <ThirdSessionPrompts />}
        {!thirdSession &&
          <Prompts>
            <Prompts.Q str="prose.howDoesThisCompare" />
            <Prompts.R str="prose.youDotDotDot" />
          </Prompts>
        }
        {/* EXAM RESULTS */}
        <SectionHeader color="blue" icon="fas fa-eye" str="titles.examResults" />
        {!thirdSession &&
          <Prompts>
            <Prompts.P str="prose.ifItsOkayOpticNerve" />
          </Prompts>
        }
        {/* EXAM RESULTS - THE OPTIC NERVE */}
        <Header str="titles.theOpticNerve" />
        <Card>
          <Card.Pad>
            <Image src="/images/donuts.png" />
            <Paragraph str="prose.donuts" />
          </Card.Pad>
        </Card>
        {patient.fields.lowVision === "NO" && <OpticNerveProgression/>}

        <Prompts>
          {patient.fields.lowVision === "NO" && (
            <React.Fragment>
              <Prompts.Q str="prose.whatNoticeInVideo" />
              <Prompts.R str="prose.you" />
            </React.Fragment>
          )}
          {!patient.hasOpticNerves && !thirdSession &&
            <Prompts.P><Paragraph str="prose.lowVisionTalkAboutOctTest"/></Prompts.P>}
        </Prompts>
        {patient.hasOpticNerves &&
          <Fragment>
            {/* EXAM RESULTS - YOUR OPTIC NERVES */}
            <Header str="titles.yourOpticNerves" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.firstTestResultWeWill" />
              </Card.Pad>
            </Card>
            <Prompts.P><Paragraph str="prose.photosOfOpticNerves"/></Prompts.P>
            <PatientImages
              left={patient.fields.leftOpticNerve}
              leftDate={patient.fields.leftOpticNerveDate}
              right={patient.fields.rightOpticNerve}
              rightDate={patient.fields.rightOpticNerveDate}
            />
            {thirdSession && <ThirdSessionPrompts />}
            {!thirdSession &&
                <Prompts>
                  <Prompts.P><Paragraph str="prose.lowVisionTalkAboutOctTest"/></Prompts.P>
                </Prompts>
            }
          </Fragment>
        }
        <Header str="titles.octTest" />
        <Card>
          <Card.Pad>
            <Paragraph str="prose.octTest"/>
          </Card.Pad>
        </Card>
        <Card>
          <Card.Pad>
            <Paragraph centered style={{fontSize: '1.5rem'}} str="prose.trafficLight" />
            {/* <Row>
              <Row.Cell><TrafficLight /></Row.Cell>
              <Row.Cell>
                <Paragraph>Red an area of damaged tissue</Paragraph>
                <Paragraph>Yellow means an area of possible concern</Paragraph>
                <Paragraph>Green means an area of healthy tissue</Paragraph>
              </Row.Cell>
            </Row> */}
            <TrafficLight />
            {
              patient.fields.lowVision==="YES" &&
                <Paragraph centered style={{fontSize: '1.5rem'}} str="prose.trafficLightBlind" />
            }
          </Card.Pad>
        </Card>
        <Header str="titles.yourTestResults" />
        {patient.fields.lowVision === "YES" && <Prompts>
            <Prompts.P>
                <Paragraph str="prose.lowVisionOctTestResults" inserts={{
                    octLeftGreen, octLeftYellow, octLeftRed, octRightGreen, octRightYellow, octRightRed
                }} />
            </Prompts.P>
        </Prompts>}
        <Card>
          <Card.Pad>
            <Text str="titles.date"/>: {patient.fields.octDate || 'N/A'}
            <Row>
              <Row.Cell centered><OCT eye="right" /></Row.Cell>
              <Row.Cell centered><OCT eye="left" /></Row.Cell>
            </Row>
            <Row>
              <Row.Cell centered><Text style={{fontSize: '0.9rem', color: '#888'}} str="titles.rightEye" /></Row.Cell>
              <Row.Cell centered><Text style={{fontSize: '0.9rem', color: '#888'}} str="titles.leftEye" /></Row.Cell>
            </Row>
            <Paragraph str="prose.octTestResults" />
          </Card.Pad>
        </Card>
        {/* <PatientImages
          left="/screening/oct-left.png"
          leftDate="January 1, 2019"
          right="/screening/oct-right.png"
          rightDate="January 1, 2019"
        /> */}
        <Prompts>
          <Prompts.Q>
            <Paragraph str="prose.questionAboutTestResults"/>
          </Prompts.Q>
          <Prompts.R>
            <Paragraph str="prose.you"/>
          </Prompts.R>
        </Prompts>
        {/* EXAM RESULTS - THE VISUAL FIELD TEST */}
        <Header str="titles.theVisualFieldTest" />
        {!thirdSession &&
          <Prompts>
            <Prompts.Q str="prose.nextVisualFieldTest" />
          </Prompts>
        }
        <Card>
          <Card.Pad>
            <Paragraph str="prose.visualFieldTestCreates" />
            <Paragraph str="prose.testIsImportant" />
            {
              patient.fields.lowVision === "YES" ? <Paragraph str="prose.evenIfLostVision"/>
                : <React.Fragment>
                  <Paragraph str="prose.yourDoctorCanCompare" />
                  <Paragraph str="prose.asGlaucomaGetsWorse" />
                </React.Fragment>
            }
          </Card.Pad>
        </Card>
        {patient.hasVFIs &&
          <Fragment>
            {/* EXAM RESULTS - YOUR TEST RESULTS */}
            <Header str="titles.yourTestResults" />
            <Card>
              <Card.Pad>
                {patient.fields.lowVision === "YES" ? <Paragraph str="prose.100PercentVeryBestLowVision"/> : <Paragraph str="prose.100PercentVeryBest" />}
                {patient.mostRecentLeftVFI && <Paragraph str="prose.yourVisionInLeftEye" inserts={{ vfi: patient.mostRecentLeftVFI }} />}
                {patient.mostRecentRightVFI && <Paragraph str="prose.yourVisionInRightEye" inserts={{ vfi: patient.mostRecentRightVFI }} />}
                {patient.fields.lowVision === "YES"? <Paragraph str="prose.byTakingYourMedicationsLowVision"/>:<Paragraph str="prose.byTakingYourMedications" />}
              </Card.Pad>
            </Card>
          </Fragment>
        }
        {patient.hasVisualFields &&
          <Fragment>
            {/* EXAM RESULTS - NORMAL VISUAL FIELD */}
            <Header str="titles.normalVisualField" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.lookAtVisualFieldTests" />
              </Card.Pad>
              <Card.Divider />
              <Card.Pad>
                <Image src="/images/normal-visual-field.png" />
              </Card.Pad>
            </Card>
            {patient.hasRecentVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR RECENT VISUAL FIELDS */}
                <Header str="titles.yourRecentVisualFields" />
                <PatientImages
                  left={patient.fields.leftRecentField}
                  right={patient.fields.rightRecentField}
                  leftVFI={patient.fields.leftRecentVFI}
                  rightVFI={patient.fields.rightRecentVFI}
                  leftDate={patient.fields.leftRecentFieldDate}
                  rightDate={patient.fields.rightRecentFieldDate}
                />
              </Fragment>
            }
            {patient.hasPreviousVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR PREVIOUS VISUAL FIELDS */}
                <Header str="titles.yourPreviousVisualFields" />
                <PatientImages
                  left={patient.fields.leftPreviousField}
                  right={patient.fields.rightPreviousField}
                  leftVFI={patient.fields.leftPreviousVFI}
                  rightVFI={patient.fields.rightPreviousVFI}
                  leftDate={patient.fields.leftPreviousFieldDate}
                  rightDate={patient.fields.rightPreviousFieldDate}
                  headerStr="titles.yourPreviousVisualFields"
                />
              </Fragment>
            }
            {patient.hasBaselineVisualFields &&
              <Fragment>
                {/* EXAM RESULTS - YOUR BASELINE VISUAL FIELDS */}
                <Header str="titles.yourBaselineVisualFields" />
                <PatientImages
                  left={patient.fields.leftBaselineField}
                  right={patient.fields.rightBaselineField}
                  leftVFI={patient.fields.leftBaselineVFI}
                  rightVFI={patient.fields.rightBaselineVFI}
                  leftDate={patient.fields.leftBaselineFieldDate}
                  rightDate={patient.fields.rightBaselineFieldDate}
                  headerStr="titles.yourBaselineVisualFields"
                />
              </Fragment>
            }
          </Fragment>
        }
        {!thirdSession && patient.fields.lowVision === "NO" &&
          <Prompts>
            <Prompts.Q str="prose.whatIfAnyQuestions" />
          </Prompts>
        }
        {thirdSession && <ThirdSessionPrompts />}
        {/* VISUAL FIELD PROGRESSION */}

        {patient.fields.lowVision === "NO" &&
          <React.Fragment>
            <SectionHeader color="blue" icon="fas fa-hourglass-half" str="titles.visualFieldProgression"/>
            {!thirdSession &&
              <Prompts>
                <Prompts.P str="prose.youveSharedSomeThoughts"/>
              </Prompts>
            }
            <Card>
              <Card.Pad>
                <Paragraph str="prose.howGlaucomaAffectsYourVision"/>
                <Paragraph str="prose.glaucomaIsSerious"/>
              </Card.Pad>
            </Card>
            <VisualFieldProgression/>
            {!thirdSession &&
              <Prompts>
                <Prompts.Q str="prose.peopleFindThisScary"/>
                <Prompts.R str="prose.youFeel"/>
              </Prompts>
            }
            {thirdSession &&
              <Prompts>
                <Prompts.Q>
                  <OrderedList>
                    <OrderedList.Item str="prose.whatDidItFeel"/>
                    <OrderedList.Item str="prose.whatsYourReaction"/>
                  </OrderedList>
                </Prompts.Q>
                <Prompts.R str="prose.itSoundsLike"/>
                <Prompts.P>
                  <Paragraph str="prose.greatNextArea"/>
                  <Paragraph str="prose.orSayNextArea"/>
                </Prompts.P>
              </Prompts>
            }
          </React.Fragment>
        }
        {/* TREATMENT PLAN */}
        <SectionHeader color="blue" icon="fas fa-search-plus" str="titles.treatmentPlan" />
        {!thirdSession &&
          <Prompts>
            <Prompts.P str="prose.beginningOfSession" />
          </Prompts>
        }
        <Card>
          <Card.Pad>
            <Paragraph str="prose.onlyKnownTreatment" />
          </Card.Pad>
        </Card>
        {patient.hasMedications &&
          <Fragment>
            {/* TREATMENT PLAN - MEDICATIONS */}
            <Header str="titles.medications" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.doctorHasRecommended" inserts={{ doctor: patient.fields.doctor }} />
              </Card.Pad>
            </Card>
            {patient.fields.medications.map((m, i) => (
              <Card key={i}>
                <Card.Pad>
                  <MedicationDisplay medication={m} />
                </Card.Pad>
                <Card.Divider />
                <Card.Pad>
                  <Paragraph str={`choices.medicationDescription.${m.prescription}`} />
                </Card.Pad>
              </Card>
            ))}
            {!thirdSession &&
              <Prompts>
                <Prompts.Q str="prose.doYouKnow" />
              </Prompts>
            }
            <Card>
              <Card.Pad>
                <Paragraph str="prose.glaucomaMedicationTip" />
              </Card.Pad>
            </Card>
          </Fragment>
        }
        {patient.hasSurgeries &&
          <Fragment>
            {/* TREATMENT PLAN - SURGERIES */}
            <Header str="titles.surgeries" />
            <Card>
              <Card.Pad>
                <Paragraph str="prose.toHelpControlYourGlaucoma" />
              </Card.Pad>
            </Card>
            {patient.fields.surgeries.map((s, i) => (
              <Card key={i}>
                <Card.Title str={`choices.surgery.${s}`} />
                <Card.Pad>
                  <Paragraph str={`choices.surgeryDescription.${s}`} />
                </Card.Pad>
              </Card>
            ))}
          </Fragment>
        }
        {thirdSession &&
          <Prompts>
            <Prompts.Q str="prose.whatIfAnyTreatments" />
            <Prompts.R str="prose.thatsAGoodQuestion" />
            <Prompts.P>
              <Paragraph str="prose.greatNextArea2" />
              <Paragraph str="prose.orSayNextArea" />
            </Prompts.P>
          </Prompts>
        }

        {!thirdSession &&
          <Fragment>
            <Prompts>
              <Prompts.Q str="prose.whatIfAnyTreatments" />
            </Prompts>
            {/* SUMMARY */}
            <SectionHeader color="blue" icon="fas fa-file-alt" str="titles.summary" />
            {!thirdSession &&
              <Prompts>
                <Prompts.Q str="prose.whatStoodOutToYou" />
                <Prompts.R str="prose.reflect" />
              </Prompts>
            }
            <SummaryBullet color="blue" icon="far fa-dot-circle">
              <Text str="prose.youHaveBeenDiagnosedWith" />&nbsp;&nbsp;
              <Text str={`choices.diagnosis.${patient.fields.diagnosis}`} />
            </SummaryBullet>
            {patient.hasVFIs &&
              <SummaryBullet color="blue" icon="fas fa-eye">
                {patient.mostRecentLeftVFI && <Text str="prose.yourVisionInLeftEye" inserts={{ vfi: patient.mostRecentLeftVFI }} />}
                {patient.mostRecentLeftVFI && patient.mostRecentRightVFI && <br />}
                {patient.mostRecentRightVFI && <Text str="prose.yourVisionInRightEye" inserts={{ vfi: patient.mostRecentRightVFI }} />}
              </SummaryBullet>
            }
            {patient.fields.lowVision === "NO" &&
              <SummaryBullet color="blue" icon="fas fa-hourglass-half" str="prose.graduallyBlindspotsDevelop" />
            }
            {patient.hasMedications &&
              <SummaryBullet color="blue" icon="fas fa-search-plus">
                <Text str="prose.youHaveBeenPrescribed" />&nbsp;&nbsp;
                {patient.fields.medications.map((m, i) => (
                  <Fragment key={i}>
                    <Text str={`choices.medication.${m.prescription}`} />
                    {i !== patient.fields.medications.length - 1 && ', '}
                  </Fragment>
                ))}
              </SummaryBullet>
            }
            {patient.hasSurgeries &&
              <SummaryBullet color="blue" icon="fas fa-search-plus">
                <Text str="prose.surgeriesYouveHad" />&nbsp;&nbsp;
                {patient.fields.surgeries.map((s, i) => (
                  <Fragment key={i}>
                    <Text str={`choices.surgery.${s}`} />
                    {i !== patient.fields.surgeries.length - 1 && ', '}
                  </Fragment>
                ))}
              </SummaryBullet>
            }
            <SummaryBullet color="blue" icon="fas fa-question" str="prose.questionsForYourDoctor" />
            {!thirdSession &&
              <Prompts>
                <Prompts.P str="prose.nextThingLikeToReview" />
              </Prompts>
            }
          </Fragment>
        }
        {/* PAGINATE */}
        <Paginate>
          {thirdSession &&
            <Paginate.Button
              color="red"
              str="titles.goal"
              to={`/goal/third/${patientID}`}
            />
          }
          {!demo &&
            <Paginate.Button next
              color="orange"
              str="titles.use"
              to={`/use/${session}/${patientID}`}
            />
          }
          {demo &&
            <Paginate.Button next
              color="orange"
              str="titles.use"
              to="/demo/use"
            />
          }
        </Paginate>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Learn/LearnSession123.js